<template>
  <div class="custom-form cmi-res">
    <div class="panel-body">
      <div class="panel panel-info cmi-search-header-panel">
        <div class="row cmi-search-wrapper">
          <div class="col-md-10 col-md-offset-1">
            <div class="cmi-search-header">
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Select by event caption</span>
                </div>
                <div class="col-md-6 header-middle">
                  <select
                    id="evt_FilterLabel"
                    name="evt_FilterLabel"
                    @change="getFormDataByLabel"
                    v-model.trim="evt_FilterLabel"
                    class="form-control"
                  >
                    <option></option>
                    <option
                      v-for="item in eventLabels"
                      v-bind:value="item.value"
                      :key="item.value"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
                <div class="col-md-2 header-right">
                  <span
                    v-if="aniLabelsLoading"
                    class="fa fa-spinner fa-spin fa-3x fa-fw"
                  ></span>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Search by event ID</span>
                </div>
                <div class="col-md-6 header-middle">
                  <masked-input
                    type="text"
                    name="evt_FilterCode"
                    class="form-control"
                    :mask="[
                      /[A-Z]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i
                    ]"
                    :guide="false"
                    :showMask="false"
                    :pipe="toUpperCase"
                    v-model.trim="evt_FilterCode"
                    spellcheck="false"
                  >
                  </masked-input>
                </div>
                <div class="col-md-2 cmi-search-header-btn-search">
                  <button
                    @click="getFormDataByCode"
                    v-bind:disabled="disableCriteriaMet_evt_FilterCode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Search
                  </button>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-6 col-md-offset-3 cmi-search-header-btn-add">
                  <button
                    @click="newFormData"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Add new item
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Event details</h3>
        </div>

        <div class="panel-body">
          <div v-if="showEventId" class="form-group">
            <label for="evt_EventCode">Event ID</label>
            <div
              id="evt_EventCode"
              name="evt_EventCode"
              class="form-control cmi-file-label"
            >
              {{ fdata.evt_EventCode }}
            </div>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_File') }"
          >
            <label for="evt_File">Select event poster image</label>
            <input
              ref="evt_File"
              id="evt_File"
              name="evt_File"
              @change="onFileChange_evt_File"
              v-validate.initial="{
                required: validateFileInput,
                mimes: ['image/*'],
                size: 30000
              }"
              class="form-control"
              type="file"
            />
            <span class="help-block">{{ errors.first("evt_File") }}</span>
          </div>

          <div class="cmi-profile-image">
            <p>Event poster preview</p>
            <img
              ref="evt_FilePreview"
              v-bind:src="fdata.evt_FilePreview"
              class="img-thumbnail"
              alt=">Event poster (thumbnail)"
            />
          </div>
          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventCaption') }"
          >
            <label for="evt_EventCaption">Event caption</label>
            <input
              id="evt_EventCaption"
              name="evt_EventCaption"
              v-model.trim="fdata.evt_EventCaption"
              v-validate.initial="{ required: true, max: 100 }"
              maxlength="100"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("evt_EventCaption")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventDetails') }"
          >
            <label for="evt_EventDetails">Event details</label>
            <textarea
              id="evt_EventDetails"
              name="evt_EventDetails"
              v-model.trim="fdata.evt_EventDetails"
              v-validate.initial="{ required: true, max: 1000 }"
              maxlength="1000"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("evt_EventDetails")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventLocation') }"
          >
            <label for="evt_EventLocation">Event location</label>
            <select
              id="evt_EventLocation"
              name="evt_EventLocation"
              v-model.number="fdata.evt_EventLocation"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option
                v-for="item in addressLabels"
                v-bind:value="item.value"
                :key="item.value"
                >{{ item.label }}</option
              >
              <option value="-1">Other</option>
            </select>
            <span
              v-if="aniAddressLoading"
              class="fa fa-spinner fa-spin fa-3x fa-fw"
            ></span>
            <span class="help-block">{{
              errors.first("evt_EventLocation")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventLocationText') }"
          >
            <label for="evt_EventLocationText">Specify event location</label>
            <textarea
              id="evt_EventLocationText"
              name="evt_EventLocationText"
              v-model.trim="fdata.evt_EventLocationText"
              v-validate.initial="{
                required: !disableCriteriaMet_evt_EventLocationText,
                max: 200
              }"
              maxlength="200"
              v-bind:disabled="disableCriteriaMet_evt_EventLocationText"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("evt_EventLocationText")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventStartDate') }"
          >
            <label for="evt_EventStartDate"
              >Event start date and time (example 01-Feb-2019 10:30)</label
            >
            <input
              id="evt_EventStartDate"
              name="evt_EventStartDate"
              v-model.trim="fdata.evt_EventStartDate"
              v-validate.initial="{
                required: true,
                valid_datetime_format: { active: true }
              }"
              placeholder="DD-MMM-YYYY HH:MM"
              maxlength="17"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("evt_EventStartDate")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventEndDate') }"
          >
            <label for="evt_EventEndDate"
              >Event end date and time (example 01-Feb-2019 10:30)</label
            >
            <input
              id="evt_EventEndDate"
              name="evt_EventEndDate"
              v-model.trim="fdata.evt_EventEndDate"
              v-validate.initial="{
                required: true,
                valid_datetime_format: { active: true },
                lookup_compare: {
                  opt: 'gteq',
                  targetValue: fdata.evt_EventStartDate,
                  dataType: 'date'
                }
              }"
              placeholder="DD-MMM-YYYY HH:MM"
              maxlength="17"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("evt_EventEndDate")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_AdvertStartDate') }"
          >
            <label for="evt_AdvertStartDate"
              >Advert start date and time (example 01-Feb-2019 10:30)</label
            >
            <input
              id="evt_AdvertStartDate"
              name="evt_AdvertStartDate"
              v-model.trim="fdata.evt_AdvertStartDate"
              v-validate.initial="{
                required: true,
                valid_datetime_format: { active: true }
              }"
              placeholder="DD-MMM-YYYY HH:MM"
              maxlength="17"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("evt_AdvertStartDate")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_AdvertEndDate') }"
          >
            <label for="evt_AdvertEndDate"
              >Advert end date and time (example 01-Feb-2019 10:30)</label
            >
            <input
              id="evt_AdvertEndDate"
              name="evt_AdvertEndDate"
              v-model.trim="fdata.evt_AdvertEndDate"
              v-validate.initial="{
                required: true,
                valid_datetime_format: { active: true },
                lookup_compare: {
                  opt: 'gteq',
                  targetValue: fdata.evt_AdvertStartDate,
                  dataType: 'date'
                }
              }"
              placeholder="DD-MMM-YYYY HH:MM"
              maxlength="17"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("evt_AdvertEndDate")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventRecurrence') }"
          >
            <label for="evt_EventRecurrence">Recurrence</label>
            <select
              id="evt_EventRecurrence"
              name="evt_EventRecurrence"
              v-model="fdata.evt_EventRecurrence"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">One time only</option>
              <option value="2">Daily</option>
              <option value="3">Weekly</option>
              <option value="4">Monthly</option>
              <option value="5">Yearly</option>
            </select>
            <span class="help-block">{{
              errors.first("evt_EventRecurrence")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventSpeaker') }"
          >
            <label for="evt_EventSpeaker">Speaker</label>
            <select
              id="evt_EventSpeaker"
              name="evt_EventSpeaker"
              v-model.number="fdata.evt_EventSpeaker"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option
                v-for="item in personLabels"
                v-bind:value="item.value"
                :key="item.value"
                >{{ item.label }}</option
              >
              <option value="-1">Other</option>
            </select>
            <span
              v-if="aniPeopleAtSiteLoading"
              class="fa fa-spinner fa-spin fa-3x fa-fw"
            ></span>
            <span class="help-block">{{
              errors.first("evt_EventSpeaker")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_EventSpeakerText') }"
          >
            <label for="evt_EventSpeakerText">Other speakers</label>
            <textarea
              id="evt_EventSpeakerText"
              name="evt_EventSpeakerText"
              v-model.trim="fdata.evt_EventSpeakerText"
              v-validate="{
                required: !disableCriteriaMet_evt_EventSpeakerText,
                max: 1000
              }"
              maxlength="1000"
              v-bind:disabled="disableCriteriaMet_evt_EventSpeakerText"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("evt_EventSpeakerText")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('evt_Status') }"
          >
            <label for="evt_Status">Status</label>
            <select
              id="evt_Status"
              name="evt_Status"
              v-model.number="fdata.evt_Status"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
              <option value="90">Delete</option>
            </select>
            <span class="help-block">{{ errors.first("evt_Status") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-event"
        :width="400"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>

      <div class="btn-submit-wrapper">
        <div v-if="showAnimation" class="cc-animation">
          <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
          <span>Form submission in progress</span>
        </div>
        <div class="cc-submit-btn-wrapper">
          <button
            v-on:click="saveFormData"
            v-bind:disabled="showAnimation"
            type="submit"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VueRecaptcha from "vue-recaptcha";
import { mapActions } from "vuex";
import axios from "axios";
const path = "/dist/assets/images/ResourceImages/";
export default {
  // components: {
  //   VueRecaptcha,
  // },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        evt_EventCode: "",
        evt_EventPoster: "",
        evt_EventCaption: "",
        evt_EventDetails: "",
        evt_EventLocation: null,
        evt_EventLocationText: "",
        evt_EventStartDate: "",
        evt_EventEndDate: "",
        evt_AdvertStartDate: "",
        evt_AdvertEndDate: "",
        evt_EventRecurrence: null,
        evt_EventSpeaker: null,
        evt_EventSpeakerText: "",
        evt_Branch: null,
        evt_Status: 1,
        evt_FilePreview: `${path}cmi_no_image.jpg`,
        evt_FilePreviewEditUrl: ""
      },
      showAnimation: false,
      subformIndex: 0,
      alertMessage: "",
      eventLabels: [],
      personLabels: [],
      addressLabels: [],
      evt_FilterLabel: "",
      evt_FilterCode: "",
      validateFileInput: true,
      aniLabelsLoading: false,
      aniPeopleAtSiteLoading: false,
      aniAddressLoading: false,
      fd: new FormData()
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    saveFormData: async function() {
      this.fd.delete("json");
      this.fd.append("json", JSON.stringify(this.fdata));

      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-event");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}UpdateFormData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fd, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }
      if (rData != 0) {
        this.showAnimation = false;
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-event");
        return;
      }
      if (!this.fdata.pkey) {
        this.validateFileInput = true;
        this.resetFormData();
      }

      await this.getEventLabels();
      this.alertMessage = "Your form has been submitted successfully";
      this.$modal.show("alert-dialog-event");
      this.showAnimation = false;
    },
    getFormDataByLabel: async function() {
      this.evt_FilterCode = "";
      if (!this.evt_FilterLabel) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.evt_FilterLabel }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        if (rData.evt_EventPoster) {
          this.fdata.evt_FilePreview = rData.evt_EventPoster;
          this.fdata.evt_FilePreviewEditUrl = rData.evt_EventPoster;
        }
        this.$validator.errors.remove("evt_File");
        this.validateFileInput = false;
      }

      this.aniLabelsLoading = false;
    },
    getFormDataByCode: async function() {
      this.evt_FilterLabel = "";
      const evt_FilterCode = this.evt_FilterCode.replace(/\s/g, "");
      if (!evt_FilterCode) {
        this.resetFormData();
        return;
      }

      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pcode: evt_FilterCode }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataByCode`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        if (rData.evt_EventPoster) {
          this.fdata.evt_FilePreview = rData.evt_EventPoster;
          this.fdata.evt_FilePreviewEditUrl = rData.evt_EventPoster;
        }
        this.$validator.errors.remove("evt_File");
        this.validateFileInput = false;
      } else {
        this.resetFormData();
        this.alertMessage = "Item not found";
        this.$modal.show("alert-dialog-event");
      }

      this.aniLabelsLoading = false;
    },

    getEventLabels: async function() {
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { siteId: 2 }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetEventLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.eventLabels, rData);
      }
      this.aniLabelsLoading = false;
    },

    getPersonLabels: async function() {
      this.aniPeopleAtSiteLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetPersonLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniPeopleAtSiteLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.personLabels, rData);
      }
      this.aniPeopleAtSiteLoading = false;
    },

    getAddressLabels: async function() {
      this.aniAddressLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetAddressLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniAddressLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.addressLabels, rData);
      }
      this.aniAddressLoading = false;
    },

    resetFormData: function() {
      Object.assign(this.fdata, {
        pkey: 0,
        evt_EventCode: "",
        evt_EventPoster: "",
        evt_EventCaption: "",
        evt_EventDetails: "",
        evt_EventLocation: null,
        evt_EventLocationText: "",
        evt_EventStartDate: "",
        evt_EventEndDate: "",
        evt_AdvertStartDate: "",
        evt_AdvertEndDate: "",
        evt_EventRecurrence: null,
        evt_EventSpeaker: null,
        evt_EventSpeakerText: "",
        evt_Branch: null,
        evt_Status: 1,
        evt_FilePreview: `${path}cmi_no_image.jpg`,
        evt_FilePreviewEditUrl: ""
      });
      this.fd = new FormData();
      this.$refs.evt_File.value = null;
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-event");
    },
    newFormData: function() {
      this.resetFormData();
      this.evt_FilterLabel = "";
      this.evt_FilterCode = "";
      this.validateFileInput = true;
    },
    onFileChange_evt_File: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        if (this.fdata.evt_FilePreviewEditUrl) {
          this.fdata.evt_FilePreview = this.fdata.evt_FilePreviewEditUrl;
        }
        return;
      }

      this.fdata.evt_FilePreview = "";
      this.fd.delete("evt_File");
      this.fd.append("evt_File", files[0]);
      let reader = new FileReader();
      let self = this;
      reader.onload = function(e) {
        self.$refs.evt_FilePreview.src = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    toUpperCase: function(value) {
      return value.toUpperCase();
    }
  },
  watch: {
    disableCriteriaMet_evt_EventLocationText: function(newValue) {
      if (newValue == true) {
        this.fdata.evt_EventLocationText = "";
      }
    },
    disableCriteriaMet_evt_EventSpeakerText: function(newValue) {
      if (newValue == true) {
        this.fdata.evt_EventSpeakerText = "";
      }
    }
  },
  computed: {
    showEventId: function() {
      if (this.fdata.evt_EventCode) {
        return true;
      }
      return false;
    },
    disableCriteriaMet_evt_FilterCode: function() {
      if (this.evt_FilterCode && this.evt_FilterCode.length == 16) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_evt_EventLocationText: function() {
      if (
        this.fdata.evt_EventLocation != null &&
        [-1].indexOf(this.fdata.evt_EventLocation) != -1
      ) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_evt_EventSpeakerText: function() {
      if (
        this.fdata.evt_EventSpeaker != null &&
        [-1].indexOf(this.fdata.evt_EventSpeaker) != -1
      ) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.getEventLabels();
    await this.getAddressLabels();
    await this.getPersonLabels();
  }
};
</script>
